<template>
  <div :class="contentWidth === 'boxed' ? 'container p-0' : null">
    <router-view />
  </div>
</template>

<script>
export default {
  computed: {
    contentWidth() {
      return this.$store.state.appConfig.layout.contentWidth
    },
  },
}
</script>
